import React, {useEffect, useState} from 'react'
import '../product.css'

const NumberInput = React.memo((props: any) => {
  const { row, column, table, getValue } = props.props;
  const [editValue, setValue] = useState<number | string | undefined>(getValue());

  useEffect(() => {
    const cellValue = getValue();
    if (cellValue !== undefined && cellValue !== null) {
      setValue(cellValue);
    } else {
      setValue('');
    }
    
  }, [getValue()]);

  const onBlur = () => {
    // Convert to number or null before updating
    const valueToUpdate = editValue === '' ? null : Number(editValue);
    table.options.meta?.updateData(row.index, column.id, valueToUpdate);
  };

  const updateValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return (
    <div className='input-group'>
      <input
        // style={{ width: '110px' }}
        className='table-input bg-white'
        type='number'
        value={editValue}
        placeholder={props.placeholder}
        onChange={updateValue}
        onBlur={onBlur}
      />
    </div>
  );
}, (prevProps, nextProps) => {
  
  return (
    prevProps.props.getValue() === nextProps.props.getValue() &&
    prevProps.placeholder === nextProps.placeholder
  );
});

export default NumberInput
